import { type ReactNode, useRef } from 'react'

import { MainScrollProvider } from 'src/layouts/_shared/MainScrollContext'

import { BusinessPortalMobileNavigation } from './BusinessPortalMobileNavigation'
import './business-portal-frame.css'

/** Owns the viewport and main scroll region; route content stays within it. */
export const BusinessPortalFrame = ({
  children,
  expanded,
  isAgentWorkspace,
  isAgentActivityRoute,
  isDesktop,
  mobileOpen,
  navigation,
  onMobileOpenChange,
  topBar,
}: {
  children: ReactNode
  expanded: boolean
  isAgentWorkspace: boolean
  isAgentActivityRoute: boolean
  isDesktop: boolean
  mobileOpen: boolean
  navigation: ReactNode
  onMobileOpenChange: (open: boolean) => void
  topBar: ReactNode
}) => {
  const mainRef = useRef<HTMLElement>(null)
  const NavigationElement = isAgentWorkspace ? 'aside' : 'nav'
  const label = isAgentWorkspace
    ? 'AI Agent navigation'
    : 'business portal navigation'
  return (
    <div className="business-portal-frame">
      {topBar}
      <div className="business-portal-frame-row">
        {isDesktop ? (
          <NavigationElement
            aria-label={label}
            className="business-portal-frame-nav"
            data-expanded={expanded}
            data-agent={isAgentWorkspace}
          >
            {navigation}
          </NavigationElement>
        ) : (
          <BusinessPortalMobileNavigation
            open={mobileOpen}
            onOpenChange={onMobileOpenChange}
            label={label}
          >
            {navigation}
          </BusinessPortalMobileNavigation>
        )}
        <main
          ref={mainRef}
          className="business-portal-frame-main"
          data-agent={isAgentWorkspace && !isAgentActivityRoute}
        >
          <MainScrollProvider value={mainRef}>{children}</MainScrollProvider>
        </main>
      </div>
    </div>
  )
}
